module.exports = __webpack_public_path__ + "img/header.4b3a885b.png";